module.exports = __webpack_public_path__ + "img/noticias_mobile.b51970d1.jpg";